import * as React from 'react';

import { FilterModal } from '../../components/FilterModal';
import { GuestsCountContainer } from '../GuestsCountContainer';
import { LivingConditionsContainer } from '../LivingConditions';

interface IGuestsModalContainerProps {
  onResetClick(): void;
  onApplyClick(): void;
  onClose(): void;
}

export const GuestsModalContainer = React.forwardRef<HTMLDivElement, IGuestsModalContainerProps>(
  ({ onResetClick, onApplyClick, onClose }, ref) => {
    return (
      <FilterModal ref={ref} title="Гости" onResetClick={onResetClick} onApplyClick={onApplyClick} onClose={onClose}>
        <>
          <GuestsCountContainer />
          <LivingConditionsContainer contentPadding={false} />
        </>
      </FilterModal>
    );
  },
);

GuestsModalContainer.displayName = 'GuestsModalContainer';
